// General Events - Default On Load
function defaultOnLoad(timeoOut) {
  setTimeout(() => {
    const productSlug = document.getElementById(`currentVariant-slug`)
    const currentVariantId = document.getElementById(`currentVariant-id`)
    // console.log('custom.js - currentVariantId => ', currentVariantId)
    let inventoryQuantity = 1
    let productHandle = ''
    if (currentVariantId) {
      let variantIdTemp = 'variant-id-' + currentVariantId.innerHTML
      // console.log('custom.js - variantIdTemp => ', variantIdTemp)
      const variantId = document.getElementById(variantIdTemp)
      // console.log('custom.js - variantId => ', variantId)
      productHandle =
        productSlug && productSlug.innerHTML ? productSlug.innerHTML : ''
      inventoryQuantity =
        variantId && variantId.innerHTML ? variantId.innerHTML : 1
      // console.log('custom.js - inventoryQuantity 1 => ', inventoryQuantity)
    } else {
      // Do this to initialize again for card-product popup
      defaultOnLoad(2000)
    }
    let stockCountdown = document.querySelector(
      '.shopify-app-block .heymerch-stock'
    )
    let preorderText = document.getElementById('preorder-container')
    // console.log('custom.js - preorderText => ', preorderText)
    let preorderLineItemProp = document.getElementById(
      'preorder-lineItemProperty'
    )
    // console.log('custom.js - preorderLineItemProp => ', preorderLineItemProp)
    // console.log('custom.js - inventoryQuantity 2 => ', inventoryQuantity)
    if (productHandle.includes('gift-card')) {
      if (stockCountdown) {
        stockCountdown.classList.add('hidden')
        stockCountdown.classList.remove('show')
      }
    } else {
      if (inventoryQuantity < 1) {
        // Preorder Item
        // console.log('custom.js - Preorder Item')
        if (stockCountdown) {
          stockCountdown.classList.add('hidden')
          stockCountdown.classList.remove('show')
        }
        if (preorderText) {
          preorderText.classList.remove('hidden')
        }
        if (preorderLineItemProp) {
          preorderLineItemProp.removeAttribute('disabled')
        }
      } else {
        // Regular Item
        // console.log('custom.js - Regular Item')
        if (
          stockCountdown &&
          (inventoryQuantity < 50 || inventoryQuantity > 500)
        ) {
          stockCountdown.classList.remove('hidden')
          stockCountdown.classList.add('show')
        }
        if (preorderText) {
          preorderText.classList.add('hidden')
        }
        if (preorderLineItemProp) {
          preorderLineItemProp.setAttribute('disabled', '')
        }
      }
    }
  }, timeoOut)
}
// General Events - Default On Load
// window.addEventListener('load', defaultOnLoad, false)
// defaultOnLoad(0)
defaultOnLoad(2000)

// Product Page Copy Code
function copyCouponCode() {
  /* Get the text field */
  var copyText = document.getElementById('productCouponCode')

  if (copyText) {
    /* Select the text field */
    copyText.select()
    copyText.focus()
    copyText.setSelectionRange(0, 99999) /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value)
    document.execCommand('copy')

    /* Alert the copied text */
    //   alert("Copied the text: " + copyText.value);
    var discountCode = copyText.value
    //     console.log('👀👀👀👀👀 - discountCode => ', discountCode)
    if (discountCode) {
      copyText.value = 'Copied!'
      setTimeout(() => {
        copyText.value = discountCode
      }, 3000)
    }
  }
}

// Product Page Get Discount Code
function getDiscountCodeProductPage() {
  // const getCodeBlockId = document.getElementById('announcement-bar__getCodePopup');
  // console.log('getCodeBlockId => ', getCodeBlockId);
  // if (getCodeBlockId) {
  //   getCodeBlockId.addEventListener('click', () => {
  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  // console.log('screenWidth => ', screenWidth)
  if (screenWidth > 768) {
    const getCodeBlockDesktop = document.getElementById('getCodePopupDesktop')
    // console.log('getCodeBlockDesktop => ', getCodeBlockDesktop)
    if (getCodeBlockDesktop) {
      const klaviyoIdDesktop = getCodeBlockDesktop.textContent
      // console.log('klaviyoIdDesktop => ', klaviyoIdDesktop)
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', klaviyoIdDesktop])
    }
  } else if (screenWidth <= 768) {
    const getCodeBlockMobile = document.getElementById('getCodePopupMobile')
    // console.log('getCodeBlockMobile => ', getCodeBlockMobile)
    if (getCodeBlockMobile) {
      const klaviyoIdMobile = getCodeBlockMobile.textContent
      // console.log('klaviyoIdMobile => ', klaviyoIdMobile)
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', klaviyoIdMobile])
    }
  }
  //   })
  // }
}

// Smile Popup change Z-index

document.addEventListener('DOMContentLoaded', function () {
  // console.log('klaviyo-viewed-product.liquid - load - RUN ')
  setTimeout(() => {
    var smileWidget = document.getElementById('smile-ui-container')
    if (smileWidget) {
      var currentStyle = smileWidget.getAttribute('style')
      smileWidget.setAttribute(
        'style',
        currentStyle + 'z-index:222222222 !important;'
      )
    }
  }, 5000)
})
